import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { H1 } from "../../components/h1";
import { activateRegistration } from "../../services/auth";
import { useLocale } from "../../stores/locale";

export function ControlActivate() {
  const { locale, currentLanguage } = useLocale();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    token ? "loading" : "error",
  );

  useEffect(() => {
    if (!token) {
      return;
    }

    (async () => {
      try {
        await activateRegistration(token, currentLanguage);
        setStatus("success");
      } catch {
        setStatus("error");
      }
    })();
  }, [token, currentLanguage]);

  return (
    <div className="mx-auto flex w-full max-w-xl flex-col gap-3">
      <H1>{locale.auth.activateTitle}</H1>
      {status === "loading" && <p>{locale.auth.activateLoading}</p>}
      {status === "success" && (
        <>
          <p>{locale.auth.activateSuccess}</p>
          <Link className="text-blue-700 hover:underline" to="/login">
            {locale.auth.backToLogin}
          </Link>
        </>
      )}
      {status === "error" && (
        <>
          <p className="text-red-500">{locale.auth.activateError}</p>
          <Link className="text-blue-700 hover:underline" to="/register">
            {locale.auth.registerLink}
          </Link>
        </>
      )}
    </div>
  );
}
